import { MockDirectives } from 'types/Mock';
import MockBasketService from '../implementations/MockBasketService';
import ODMBasketService from '../implementations/ODMBasketService';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';
import BasketService from '../BasketService';

export enum BasketServiceType {
  MOCK = 'MOCK',
  ODM = 'ODM',
}

export default class BasketServiceFactory {
  static createBasketService(
    type: BasketServiceType = BasketServiceType.ODM,
    mockDirectives?: MockDirectives,
  ): BasketService {
    let service: BasketServiceInterface;

    switch (type) {
      case BasketServiceType.MOCK:
        service = new MockBasketService(mockDirectives);
        break;
      default:
        service = new ODMBasketService();
    }

    return new BasketService(service);
  }
}
